<template>
  <div class="card relative transition group hover:-translate-1 hover:shadow-2">
    <div class="ar-16-9 overflow-hidden">
      <img
        :src="headerUrl"
        class="transition scale-2 group-hover:scale-0"
      >
    </div>
    <div
      :class="$style.gridLayout"
      class="p-4 grid h-64 overflow-hidden"
    >
      <h1 class="text-xl text-justify">
        {{ article.attributes.title }}
      </h1>
      <p class="text-text-lighter text-justify block-ellip-background">
        {{ article.attributes.body | stripHtml | ellipsis }}
      </p>
      <div
        v-if="disciplines.length || tags.length"
        class="flex mb-2 -mx-1 whitespace-no-wrap overflow-hidden rounded"
      >
        <DisciplineLabel
          v-for="discipline in disciplines"
          :key="discipline.id"
          :discipline="discipline"
          class="mx-1"
        />
        <TagLabel
          v-for="tag in tags"
          :key="tag.id"
          :tag="tag"
          class="mx-1"
        />
      </div>
      {{ article.attributes.published_at | dateHuge }}
    </div>
    <a
      :href="linkUrl"
      :target="linkTarget(linkUrl, article.meta.avoid_target_top_in_hrefs)"
      :title="linkTitle"
      class="absolute pin -m-px rounded
        border-2 border-transparent focus:border-brand-dark
        group-hover:border-brand transition"
    >
      <span class="sr">
        {{ article.attributes.title }}
      </span>
    </a>
  </div>
</template>

<script>
import { Type } from '@/src/server/helpers/constants'
import DisciplineLabel from '@/src/server/components/shared/DisciplineLabel'
import TagLabel from '@/src/server/components/shared/TagLabel'

export default {
  components: {
    DisciplineLabel,
    TagLabel,
  },

  props: {
    article: {
      type: Object,
      required: true,
      validator (value) {
        return value.type === Type.ARTICLE
      },
    },
    disciplines: {
      type: Array,
      default () {
        return []
      },
    },
    tags: {
      type: Array,
      default () {
        return []
      },
    },
  },

  computed: {
    linkTitle () {
      return this.article.attributes.title + '\n' +
        this.$options.filters.dateTimeHuge(this.article.attributes.published_at)
    },
    headerUrl () {
      const headerUrl = this.article.meta.header_url || {}

      return headerUrl.xhdpi || '/static/article-header.png'
    },
    linkUrl () {
      return this.article.links.domain_url || this.article.links.public_url
    },
  },
}
</script>

<style lang="scss" module>
.grid-layout {
  grid-template-rows: auto 1fr auto;
}
</style>



// WEBPACK FOOTER //
// src/server/components/Articles/Item.vue